import get from "lodash/get";

import _str from "shared/util/_str";
import * as QuestionsApi from "apps/questions/util/web";


// action types
// -----------------------------------------------------------------------------

export const SET_INITIAL_STATE = "PROFILE_EDIT.SET_INITIAL_STATE";
export const SKIP_QUESTION = "PROFILE_EDIT.SKIP_QUESTION";
export const SKIP_QUESTION_SUCCESS = "PROFILE_EDIT.SKIP_QUESTION_SUCCESS";
export const SKIP_QUESTION_FAILURE = "PROFILE_EDIT.SKIP_QUESTION_FAILURE";


// initial state
// -----------------------------------------------------------------------------

const INITIAL_STATE = {
	numQuestions: null,
	nextQuestion: null,
	nextQuestionError: null,
	isSkippingNextQuestion: false,
};

const getInitialState = () => {
	return { ...INITIAL_STATE };
};


// reducer
// -----------------------------------------------------------------------------

export const reducer = (state = getInitialState(), action) => {
	switch (action.type) {
		case SET_INITIAL_STATE: {
			const data = get(action.payload, "next_question", {});

			return {
				...state,
				userid: action.payload.userid,
				nextQuestion: data,
				numQuestions: action.payload.numQuestions,
			};
		}

		case SKIP_QUESTION: {
			return {
				...state,
				isSkippingNextQuestion: true,
			};
		}

		case SKIP_QUESTION_SUCCESS: {
			return {
				...state,
				isSkippingNextQuestion: false,
				nextQuestion: action.payload.question,
			};
		}

		case SKIP_QUESTION_FAILURE: {
			return {
				...state,
				isSkippingNextQuestion: false,
				nextQuestionError: action.payload.message,
			};
		}

		default: {
			return state;
		}
	}
};


// actions
// -----------------------------------------------------------------------------

export const setInitialState = (payload) => {
	return {
		type: SET_INITIAL_STATE,
		payload: {
			...payload,
		},
	};
};

export const skipQuestion = (question) => {
	return (dispatch) => {
		dispatch({ type: SKIP_QUESTION });

		QuestionsApi.skipQuestion(question)
			.then(() => {
				QuestionsApi.fetchNextQuestion()
					.then((res) => {
						dispatch({
							type: SKIP_QUESTION_SUCCESS,
							payload: {
								question: res,
							},
						});
					});
			})
			.catch((err) => {
				let message = _str("There was a problem skipping that question");

				if (err && err.error && err.error.message) {
					message = `${message}: ${err.error.message}`;
				} else {
					message = `${message}!`;
				}

				dispatch({
					type: SKIP_QUESTION_FAILURE,
					error: true,
					payload: {
						message,
					},
				});
			});
	};
};



// WEBPACK FOOTER //
// ./src/ducks/profile_edit.js